<template>
    <div class="white-bg down-rec">
        <h2 class="side-title">站长推荐</h2>
        <ul>
            <li><a href="html/16.html" title="腾讯QQ下载v9.1.1.24953 最新版" target="_blank"><i><img
                    src="../../assets/images/ex01.png"></i>
                <p>腾讯QQ下载v9.1.1.24953 最新版</p>
            </a></li>
            <li><a href="html/90.html" title="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版" target="_blank"><i><img
                    src="../../assets/images/ex02.png"></i>
                <p>腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</p>
            </a></li>
            <li><a href="html/91.html" title="营销qq2019最新版 v2.21.2927 官方版" target="_blank"><i><img
                    src="http://menhu.yangqq.com/d/file/p/2019/05-04/77858802ef0b011a8066feb4fa6048f1.jpg"></i>
                <p>营销qq2019最新版 v2.21.2927 官方版</p>
            </a></li>
            <li><a href="html/92.html" title="Wine QQ国际版 UbuntuKylin版 官方版" target="_blank"><i><img
                    src="../../assets/images/ex03.png"></i>
                <p>Wine QQ国际版 UbuntuKylin版 官方版</p>
            </a></li>
            <li><a href="html/93.html" title="企业QQ2019电脑版 v2.0 最新版" target="_blank"><i><img
                    src="../../assets/images/ex04.png"></i>
                <p>企业QQ2019电脑版 v2.0 最新版</p>
            </a></li>
            <li><a href="html/94.html" title="Smart QQ下载 2.0 官方版" target="_blank"><i><img
                    src="../../assets/images/ex05.png"></i>
                <p>Smart QQ下载 2.0 官方版</p>
            </a></li>
            <li><a href="html/95.html" title="腾讯QQ下载v9.1.1.24953 最新版" target="_blank"><i><img
                    src="../../assets/images/ex06.png"></i>
                <p>腾讯QQ下载v9.1.1.24953 最新版</p>
            </a></li>
            <li><a href="html/96.html" title="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版" target="_blank"><i><img
                    src="../../assets/images/ex07.png"></i>
                <p>腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</p>
            </a></li>
            <li><a href="html/97.html" title="营销qq2019最新版 v2.21.2927 官方版" target="_blank"><i><img
                    src="../../assets/images/ex08.png"></i>
                <p>营销qq2019最新版 v2.21.2927 官方版</p>
            </a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Recommend"
    }
</script>

<style scoped>

</style>